import { injectable } from 'inversify'

import { IDataModelTypeStrategy } from '../../../types/IDataModelTypeStrategy'

@injectable()
export class EventDataModelTypeStrategy implements IDataModelTypeStrategy {
  public readonly baseUrl = '/events'
  public readonly canEditColumns = false
}
